import React, { useState, useContext } from 'react';
import axios from 'axios';

import { Carrier } from '../dataProviders';


export type CreateReturnLabelRequest = {
  sales_order_id: string,
  order_number: string,
  shipping_postal_code: string,
  return_reason?: string
}

export type ReturnLabel = {
  label_id: string,
  carrier_code: Carrier,
  label_download: {
    pdf: string
  }
}

export type ReturnRecord = {
  return_labels: [ReturnLabel]
}


export type ReturnRecordState = {
  returnRecord?: ReturnRecord,
  setReturnRecord: (r: ReturnRecord) => void,
}

const ReturnLabelStateContext = React.createContext<ReturnRecordState | null>(null);

export const ReturnLabelStateProvider = ({ children }:{ children: React.ReactNode }) => {
  const [returnRecord,setReturnRecord] = useState<ReturnRecord | undefined>(undefined);

  return <ReturnLabelStateContext.Provider value={{ returnRecord, setReturnRecord }}>
    {children}
  </ReturnLabelStateContext.Provider>;
}

export const useReturnLabelState = () : ReturnRecordState => {
  const context = useContext(ReturnLabelStateContext);
  return {
    returnRecord: context?.returnRecord,
    setReturnRecord: context?.setReturnRecord as (r: ReturnRecord) => void
  };
};

export const useCreateReturn = () => {
  const { setReturnRecord } = useReturnLabelState();
  const [loading,setLoading] = useState(false);
  const [error,setError] = useState<any>();
  
  const createReturn = (returnsCenterId: string, request: CreateReturnLabelRequest) => {
    setLoading(true);
    axios.post(`/public/${returnsCenterId}/return`, request).then(
      (response) => {
        setLoading(false);
        setError(null);
        setReturnRecord(response.data);
      },
      (error) => {
        setLoading(false);
        setError(error);
      }
    );
  };

  return { createReturn, loading, error };
};
